import {BaseEvent} from "../BaseEvent";
import {DeviceAlarmStatus} from "../../models/notification/DeviceAlarmStatus";

export class DeviceStatusChangedNtf extends BaseEvent {
  public static NAME = 'deviceStatusChanged';
  public value: DeviceAlarmStatus;

  constructor(value: DeviceAlarmStatus) {
    super(DeviceStatusChangedNtf.NAME);

    this.value = value;
  }
}
